import { CatalogFaqsApiModel, CatalogFaqsModel } from './faqs.model';

export const catalogFaqsAdapter = ({
  data,
}: CatalogFaqsApiModel): CatalogFaqsModel =>
  data.map((faq) => ({
    question: faq.question,
    answer: faq.answer,
  }));
